<div class="min-h-screen flex flex-col bg-white font-toyota text-sm">
  <!-- HEADER -->
  <header class="bg-white border-b-2">
    <div class="mx-auto flex h-16 max-w-7xl items-center justify-between px-6">
      @if (brand.isLexus()) {
        <img src="assets/images/logo-lexus-round.svg" class="h-10" alt="Lexus">
      } @else {
        <img src="assets/images/logo-toyota-round.svg" class="h-10" alt="Toyota">
      }
    </div>
  </header>

  <!-- CONTENT -->
  <main class="mx-auto w-full max-w-7xl flex-1 py-4 px-2 sm:px-6 lg:px-8">
    <h1 class="text-2xl font-bold">Datenschutzinformationen</h1>
    <p class="mt-3 text-gray-600">
      Hier finden Sie die Datenschutzinformationen der Unternehmen, die ihre Daten verarbeiten.
    </p>

    <!-- GRID -->
    <div class="mt-6 grid gap-4 md:grid-cols-2 xl:grid-cols-3">
      @for (card of companyCards; track $index) {
        <div class="rounded-2xl border-[1.5px] bg-white p-4 shadow-sm transition hover:shadow-md flex flex-col">
          <div class="flex md:flex-col gap-4 md:gap-0">
            <!-- icon -->
            <div class="mb-4 flex h-14 w-14 min-w-[56px] items-center justify-center rounded-full bg-gray-100">
              <img [src]="`assets/icons/${card.icon}.png`" [ngClass]="card.iconSize">
            </div>

            <div class="flex flex-col">
              <h2 class="whitespace-pre-line text-lg font-semibold leading-snug">{{ card.title }}</h2>
              <p class="mt-2 text-gray-600">{{ card.description }}</p>
            </div>
          </div>

          <div class="mt-auto">
            @if (card.lastChanged) {
              <div class="mt-4 mb-1 text-gray-600 text-[10px] ml-[72px] md:ml-0">
                Zuletzt aktualisiert am {{ card.lastChanged }}
              </div>
            }

            <div class="mb-4 border-t border"></div>

            <div class="flex items-stretch gap-6 text-blue-700">
              <button
                class="flex items-center gap-2 hover:underline"
                (click)="getDsiDocumentHtml(card)"
              >
                <img src="assets/icons/globe-blue.png" class="h-6 w-6">
                Anzeigen
              </button>

              @if (!requestedDealer || card.dealerNumber !== requestedDealer.dealerNumber) {
                <div class="border-l border-[1.5px]"></div>
                <button
                  class="flex items-center gap-2 hover:underline"
                  (click)="getDsiDocumentPdf(card)"
                >
                  <img src="assets/icons/file-blue.png" class="h-6 w-6">
                  PDF herunterladen
                </button>
              }
            </div>
          </div>
        </div>
      }
    </div>

    <!-- BIG DOWNLOAD CARD -->
    <!--<div class="mt-6 rounded-2xl border bg-white p-2 md:p-6 shadow-sm transition hover:shadow-md cursor-pointer">
      <div class="flex items-center justify-between">
        <div class="flex items-center gap-2 md:gap-5">
          <div class="flex h-14 w-14 min-w-[56px] items-center justify-center rounded-full bg-gray-100">
            <img src="assets/icons/pdf.png" class="h-12 w-12">
          </div>

          <div class="flex flex-col">
            <h2 class="text-lg font-semibold">Alle Datenschutzinformationen als Gesamtdokument (PDF)</h2>
            <p class="mt-1 md:mt-2 text-gray-600">
              Laden Sie alle Datenschutzinformationen gesammelt in einer PDF-Datei herunter.
            </p>
          </div>
        </div>

        <img src="assets/icons/right.png" class="h-6 w-6">
      </div>
    </div>-->
  </main>

  <toycc-dsi-footer [brand]="brand" [legalEntity]="legalEntity" />
</div>
